module.exports = __webpack_public_path__ + "img/simpleheaderbj.png";